// extracted by mini-css-extract-plugin
export default {"span":"style_span__bMmit"};